<template>
  <div class="sales-pipeline-editor" >
    <SalesPipelineEditorItem 
      v-for="(item, index) in items" :key="item.id" v-model="items[index]" 
      :class="class_first_last(index)"
      @discard="onDiscard" 
      @save="onSave" 
      @delete="onDelete" 
    />

    <div class="centered py-3">
      <ButtonAddPhase @click="addPhase" />
    </div>
  </div>
</template>

<script>
import SalesPipelineEditorItem from "@/components/form/SalesPipelineEditorItem";
import ButtonAddPhase from "@/components/buttons/ButtonAddPhase";
import {computed, reactive, ref} from '@vue/composition-api';

export default {

  name: 'SalesPipelineEditor',
  props: {
    value: Array
  },
  components: {
    SalesPipelineEditorItem,
    ButtonAddPhase
  },

  setup(props, {emit}){

    //don't change props directly, instead use a computed value
    const items = computed({
      get: () => props.value,
      set: (value) => {
        console.log('set');
        emit('input', value);
      }
    });

    const counter = ref(props.value.length);

    function class_first_last(index){

      if(index === 0)
        return 'first';
      if(index === items.value.length - 1)
        return 'last';
    }

    function onDiscard(){
      emit('discard');
    }

    function onSave(){
      emit('save');
    }

    function onDelete(item){

      let to_delete = null;

      items.value.forEach((element, index) => {
        if(element.id === item)
        {
          to_delete = index;
        }
      });

      if(to_delete !== null)
      {
        items.value.splice(to_delete, 1);
      }

      emit('delete', item);
    }

    //this can also happen in the parent, when a new item is added to the model
    // >> see PipelineView >> completedStepsSalesModel 
    function addPhase(){

      //create new reactive phase
      let new_phase = reactive({
        id: "item_" + (++counter.value),
        name: "Name",
        duration: "00:00:00",
        interval: 'täglich',
        edit_mode: true
      });

      items.value.push(new_phase);
    }

    return {items, onDiscard, onSave, onDelete, addPhase, class_first_last};
  }

}
</script>

<style lang="scss" scoped>
  .centered{
    display: flex;
    justify-content: center;
  }
</style>
